export const sectionIds = [
  'Startseite',
  'Features',
  'dienstleistungen',
  'referenzen',
];
